// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer[data-v-20359b76]{font-size:.65rem;opacity:.5;font-weight:500}", ""]);
// Exports
module.exports = exports;
